<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import FastClick from 'fastclick'
import { getAppInfo } from './assets/js/http/api'
export default {
    name: 'App',
    data() {
        return {}
    },
    mounted() {
        FastClick.attach(document.body)

        var height = document.documentElement.clientHeight
        window.onload = function() {
            document.getElementById('app').style.height = height + 'px'
        }

        this.getAppInfo()
    },
    methods: {
        getAppInfo() {
            let app = [
                { port: 9485, appAbbreviation: 'test' },
                { port: 9486, appAbbreviation: 'test' },
                { port: 8081, appAbbreviation: 'test' },
                { port: 8001, appAbbreviation: 'cf' },
                { port: 8002, appAbbreviation: 'cfzy' },
                { port: 8003, appAbbreviation: 'cft' },
                { port: 8004, appAbbreviation: 'jf' },
                { port: 8005, appAbbreviation: 'cs' },
                { port: 8006, appAbbreviation: 'cxb' },
                { port: 8007, appAbbreviation: 'csb' },
                { port: 8008, appAbbreviation: 'ksy' },
                { port: 8009, appAbbreviation: 'cksf' },
                { port: 8010, appAbbreviation: 'ckgj' },
                { port: 8011, appAbbreviation: 'ct' },
                { port: 8012, appAbbreviation: 'chl' },
                { port: 8013, appAbbreviation: 'klb' },
                { port: 8014, appAbbreviation: 'kyf' },
                { port: 8015, appAbbreviation: 'hb' },
                { port: 8016, appAbbreviation: 'wszs' }
            ]
            let appAbbreviation
            if (!['', '8017', '8018'].includes(location.port)) {
                app.forEach(i => {
                    if (i.port == location.port) {
                        appAbbreviation = i.appAbbreviation
                    }
                })
            } else {
                appAbbreviation = location.href.split(location.host)[1].split('/')[1]
            }
            getAppInfo('shtop').then(res => {
                if (res.data.code == '00') {
                    this.$store.commit('changeAppInfo', {
                        appInfo: {
                            title: res.data.data.appName,
                            appLogoUrl: res.data.data.appLogoUrl,
                            appAbbreviation: res.data.data.appAbbreviation,
                            download: {
                                android: res.data.data.androidDownloadUrl,
                                ios: res.data.data.iosPageUrl
                            },
                            version: res.data.data.version,
                            releaseTime: res.data.data.releaseTime
                        }
                    })
                    sessionStorage.setItem(
                        'appInfo',
                        JSON.stringify({
                            title: res.data.data.appName,
                            appLogoUrl: res.data.data.appLogoUrl,
                            appAbbreviation: res.data.data.appAbbreviation,
                            download: {
                                android: res.data.data.androidDownloadUrl,
                                ios: res.data.data.iosPageUrl
                            },
                            version: res.data.data.version,
                            releaseTime: res.data.data.releaseTime
                        })
                    )
                }
            })
        }
    }
}
</script>

<style lang="less">
* {
    box-sizing: border-box;
}
html,
body,
#app {
    width: 100%;
    height: 100%;
    font-size: 14px;
    font-family: 'SimHei';
    margin: 0;
}
html {
    touch-action: none;
}
</style>
